const doc = [({"meta":({"forComponent":"TeamSelection", "language":"German"}), "searchLabel":"Mit Teamname suchen"})];
module.exports = doc.length <= 1 ? doc[0] : doc;